import { render, staticRenderFns } from "./AddInboxDialog.vue?vue&type=template&id=e7b12d6c&scoped=true"
import script from "./AddInboxDialog.vue?vue&type=script&lang=js"
export * from "./AddInboxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b12d6c",
  null
  
)

export default component.exports